/**
 * Simple Modal Helpers - No React State, No Re-renders
 * Create this file as: src/utils/modalHelpers.js
 */

let currentModalHandler = null;

export const setProductModalHandler = (handler) => {
  currentModalHandler = handler;
};

export const showProductModal = (productId) => {
  if (currentModalHandler) {
    currentModalHandler(productId);
  }
};